import angular from 'angular';

import 'bootstrap-legacy';
import '@uirouter/angularjs';
import '@uirouter/angular-hybrid';

import '../vendor/chosen/chosen.min';
import '../vendor/placeholders/placeholders.min';
import '../vendor/sprintf/sprintf';

import '../app-lite/app.module.ajs';

import { RouterStatesAjs } from './routing/router.states.ajs';

angular.module('app', [
  'ui.router',
  'ui.router.upgrade',

  'app-lite'
])
.config(RouterStatesAjs);
